import EmployeePerformanceLearningComponents from "../components/EmployeePerformanceLearning";
import useEmployeePerformanceLearning from "../hooks/useEmployeePerformanceLearning";

function EmployeePerformanceLearning() {
  const employeePerformanceLearningProps = useEmployeePerformanceLearning();
  return (
    <EmployeePerformanceLearningComponents
      {...employeePerformanceLearningProps}
    />
  );
}

export default EmployeePerformanceLearning;
